import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4bbff592&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/side_menu.css?vue&type=style&index=0&id=4bbff592&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/sp/side_menu.css?vue&type=style&index=1&id=4bbff592&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbff592",
  null
  
)

export default component.exports